import { createAsyncThunk } from '@reduxjs/toolkit';

import { MyInvestmentsService } from 'api';
import { DownloadInvestmentAgreementProps } from 'models/api';

import { downloadDocuments } from 'utils';

export const downloadInvestmentAgreement = createAsyncThunk(
	'myInvestments/downloadInvestmentAgreement',
	(data: DownloadInvestmentAgreementProps) =>
		downloadDocuments(
			data,
			`Investment agreement #${data.id}.pdf`,
			MyInvestmentsService.downloadInvestmentAgreement,
		),
);
